const primaryColor = '#5D578D'
const lightPrimaryColor = '#746EA2'
const secondaryColor = ' #05B2AE'
const lightSecondaryColor = '#15AAA4'
export const theme = {
	// spacing
	spacingHalf: '4px',
	spacing: '8px',
	spacing2x: '16px',
	spacing3x: '24px',
	spacing4x: '32px',
	spacing5x: '40px',
	spacing6x: '48px',
	spacing7x: '56px',
	spacing8x: '64px',

	/* font details */
	fontFamily: 'proxima-nova, sans-serif',
	// font weights
	fontLight: '300',
	fontRegular: '400',
	fontSemiBold: '600',
	fontBold: '700',

	// font sizes
	fontxxxs: '0.75em', // '12px',
	fontxxs: '0.875em', // '14px',
	fontxs: '0.93em', // 15px
	fonts: '1em', // '16px',
	fontm: '1.25em', // '20px',
	fontl: '1.5em', // '24px',
	fontxl: '2em', // '32px',
	fontxxl: '2.25em', // '36px',
	fontxxxl: '3em', // '48px',
	fonthero: '3.75em', // '60px',

	// z-index ordering
	zDefault: 0,
	zVisible: 1,
	zOverlay: 2,
	zTopOverlay: 3,
	zAlwaysShow: 4,

	/* colors */

	// base colors
	base: primaryColor,
	base2: secondaryColor,
	base3: '#14163D',
	base4: '#000000',
	white: '#ffffff',
	black: '#000000',

	// highlight colors
	highlight: '#94EFFD',
	highlight2: '#39FDC1',

	// modal colors
	modal: primaryColor,
	modalLight: lightPrimaryColor,

	primaryColor,
	lightestPrimaryColor: '#DDDDF6',
	lighterPrimaryColor: '#BCBCE7',
	lightPrimaryColor,
	secondaryColor,
	lightSecondaryColor,
	lighterSecondaryColor: '#c5eff6',
	lighterGreyColor: '#bcb9d9',
	greyColor: '#00000d',

	// state colors
	error: '#E62E2E',
	warning: '#EECB1E',
	success: '#39FDC1',

	backgroundGradient: 'linear-gradient(to right, #0D3A58, #413580)',

	boxShadow: '#00000029',

	// typography
	onBase: '#ffffff',
}

export type MissionPlayerTheme = typeof theme
